import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProtectedPrivacyService } from '@app/services/ui/protected-privacy.service';

@Injectable({
	providedIn: 'root',
})

export class PrivacyGuard implements CanActivate {

	constructor(private protectedPrivacyService: ProtectedPrivacyService,
				private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.protectedPrivacyService.statusProtected) {
			return true;
		}

		this.router
			.navigate([''], { queryParams: { returnUrl: state.url } })
			.catch(console.error);

		return false;
	}

}
